import {
  Button,
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  Input,
  useDisclosure,
  FormControl,
  FormLabel,
  useToast
} from "@chakra-ui/react";

import { useState, useEffect } from "react";
import axiosClient from "../../../../api/axiosClient";
import Select from "react-select";
import { FaPencilAlt, FaPlus } from "react-icons/fa";

export default function AddEditUserManageDrawer({ onSuccess, editData = null }) {

  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();

  const [loading, setLoading] = useState(false);

  const [departemenList, setDepartemenList] = useState([]);

  const [form, setForm] = useState({
    name: "",
    email: "",
    no_telepon: "",
    role: "karyawan",
    status: "active",
    password: "",
    departemen_id: []
  });

  /*
  =========================
  LOAD DEPARTEMEN
  =========================
  */

  useEffect(() => {
    fetchDepartemen();
  }, []);

  const fetchDepartemen = async () => {
    try {

      const res = await axiosClient.get("/departemen");

      const options = res.data.data.map((dep) => ({
        value: dep.id,
        label: dep.name
      }));

      setDepartemenList(options);

    } catch (error) {

      toast({
        title: "Failed load departemen",
        status: "error"
      });

    }
  };

  /*
  =========================
  OPEN DRAWER
  =========================
  */

  const openDrawer = () => {

    if (editData) {

      const selectedDepartemen =
        editData?.divisi?.map((d) => ({
          value: d.departemen_id,
          label: d.departemen?.name
        })) || [];

      setForm({
        name: editData.name || "",
        email: editData.email || "",
        no_telepon: editData.no_telepon || "",
        role: editData.role || "karyawan",
        status: editData.status || "active",
        password: "",
        departemen_id: selectedDepartemen
      });

    } else {

      setForm({
        name: "",
        email: "",
        no_telepon: "",
        role: "karyawan",
        status: "active",
        password: "",
        departemen_id: []
      });

    }

    onOpen();
  };

  /*
  =========================
  HANDLE INPUT
  =========================
  */

  const handleChange = (field, value) => {

    setForm((prev) => ({
      ...prev,
      [field]: value
    }));

  };

  /*
  =========================
  SUBMIT
  =========================
  */

  const handleSubmit = async () => {

    setLoading(true);

    try {

      const payload = {
        name: form.name,
        email: form.email,
        no_telepon: form.no_telepon,
        role: form.role,
        status: form.status,
        departemen_id: form.departemen_id.map((d) => d.value)
      };

      if (form.password) {
        payload.password = form.password;
      }

      if (editData) {

        await axiosClient.put(`/users/${editData.id}`, payload);

        toast({
          title: "User updated successfully",
          status: "success"
        });

      } else {

        await axiosClient.post(`/users`, payload);

        toast({
          title: "User created successfully",
          status: "success"
        });

      }

      onClose();

      if (onSuccess) onSuccess();

    } catch (error) {

      toast({
        title: "Failed save user",
        description: error?.response?.data?.message,
        status: "error"
      });

    }

    setLoading(false);

  };

  return (
    <>
      <Button
        colorScheme={editData ? "yellow" : "purple"}
        size="sm"
        leftIcon={editData ? <FaPencilAlt /> : <FaPlus />}
        onClick={openDrawer}
      >
        {editData ? "" : "Add User"}
      </Button>

      <Drawer isOpen={isOpen} placement="left" onClose={onClose} size="sm">

        <DrawerOverlay />

        <DrawerContent>

          <DrawerHeader borderBottomWidth="1px">
            {editData ? "Update User" : "Add User"}
          </DrawerHeader>

          <DrawerBody>

            <FormControl mb={4}>
              <FormLabel>Name</FormLabel>
              <Input
                value={form.name}
                onChange={(e) => handleChange("name", e.target.value)}
              />
            </FormControl>

            <FormControl mb={4}>
              <FormLabel>Email</FormLabel>
              <Input
                type="email"
                value={form.email}
                onChange={(e) => handleChange("email", e.target.value)}
              />
            </FormControl>

            <FormControl mb={4}>
              <FormLabel>No Telepon</FormLabel>
              <Input
                value={form.no_telepon}
                onChange={(e) => handleChange("no_telepon", e.target.value)}
              />
            </FormControl>

            <FormControl mb={4}>
              <FormLabel>Departemen</FormLabel>

              <Select
                options={departemenList}
                value={form.departemen_id}
                isMulti
                onChange={(value) => handleChange("departemen_id", value)}
                placeholder="Pilih departemen"
              />

            </FormControl>

            <FormControl mb={4}>
              <FormLabel>Role</FormLabel>
              <select
                value={form.role}
                onChange={(e) => handleChange("role", e.target.value)}
              >
                <option value="admin">Admin</option>
                <option value="karyawan">Karyawan</option>
                <option value="teknisi">Teknisi</option>
              </select>
            </FormControl>

            <FormControl mb={4}>
              <FormLabel>Status</FormLabel>
              <select
                value={form.status}
                onChange={(e) => handleChange("status", e.target.value)}
              >
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>
            </FormControl>

            <FormControl mb={4}>
              <FormLabel>
                Password {editData && "(Kosongkan jika tidak ingin mengubah)"}
              </FormLabel>
              <Input
                type="password"
                value={form.password}
                onChange={(e) => handleChange("password", e.target.value)}
              />
            </FormControl>

          </DrawerBody>

          <DrawerFooter gap="10px">

            <Button variant="outline" onClick={onClose}>
              Cancel
            </Button>

            <Button
              colorScheme="purple"
              onClick={handleSubmit}
              isLoading={loading}
            >
              Save
            </Button>

          </DrawerFooter>

        </DrawerContent>

      </Drawer>
    </>
  );
}